import type { Container } from "pixi.js";
import type { SymbolRemovalBurst } from "./SymbolRemovalBurst";

/**
 * Pools removal bursts and plays one at a symbol's position, re-parented into `parentNode` (the FX
 * underlay, below the symbols) at the same world position.
 */
export class SymbolRemovalBurstSpawner {
  private readonly createEffect: () => SymbolRemovalBurst;
  private readonly parentNode: Container;
  private readonly pool: SymbolRemovalBurst[] = [];

  public constructor(createEffect: () => SymbolRemovalBurst, parentNode: Container) {
    this.createEffect = createEffect;
    this.parentNode = parentNode;
  }

  public spawnAt(symbolNode: Container): void {
    const effect = this.pool.pop() ?? this.createEffect();
    const source = symbolNode.parent ?? symbolNode;
    const local = this.parentNode.toLocal(symbolNode.position, source);
    effect.position.copyFrom(local);
    this.parentNode.addChild(effect);

    effect.play(() => {
      effect.visible = false;
      effect.removeFromParent();
      this.pool.push(effect);
    });
  }

  public destroy(): void {
    for (const effect of this.pool) effect.destroy({ children: true });
    this.pool.length = 0;
  }
}
